import { ReportingControllerBaseConfig } from '../../../base';
import { DocumentDetailController } from './documentDetailInterface';
import { DocumentDetailViewProps } from './documentDetailProps';
import { BiPlus } from 'react-icons/bi';

export function createDocumentDetailController(
    config: ReportingControllerBaseConfig
): DocumentDetailController {
    return {
        useProps(context, item, props): DocumentDetailViewProps {
            const [first = null, ...rest] = item.blocks;
            if (first?.data.kind === 'form' && rest.length === 0) {
                return {
                    content: {
                        kind: 'form',
                        props: {
                            document: {
                                id: item.document.id,
                            },
                            form: {
                                id: first.data.form,
                            },
                        },
                    },
                };
            }
            return {
                content: {
                    kind: 'editor',
                    id: item.document.id,
                },
            };
        },
    };
}
